module.exports = __webpack_public_path__ + "fonts/Lato-HairlineItalic.0cf7709b.eot";